import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-6 sm:px-6" data-id="element-155" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-156" data-mp="3fze45yusr5w7">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-petrol sm:text-3xl" data-id="element-157" data-mp="3fy2z7vpm7s3i">
          Caregivers using the system
        </h2>
        <div className="mt-4 space-y-3" data-id="element-158" data-mp="36zimdb6qkcn7">
          {testimonials.map(t => <figure key={t.name} className="rounded-xl border border-petrol/10 bg-cream p-3 shadow-sm" data-id="element-159" data-mp="31zw8czj32sdc">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-160" data-mp="2x1utkqsoxf7o">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-161" data-mp="2s3jfg3vd4ijn" />)}
              </div>
              <blockquote className="mt-1.5 text-sm leading-snug sm:text-base" data-id="element-162" data-mp="q891jm0j6zhf">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-2 font-heading text-xs font-bold uppercase text-petrol sm:text-sm" data-id="element-163" data-mp="m5kkqkssonau">
                {t.name}
                <span className="block font-body text-[0.72rem] font-medium normal-case text-deep/70 sm:text-xs" data-id="element-164" data-mp="79258ndnvh5x">
                  {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}